import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';

const EMOJIS = ['🚀', '✨', '💻', '🔮', '🧠', '🤖', '💡', '⚡', '🌟', '🔥', '🎮', '🌐', '💎', '🔋', '🧩', '📊'];

const EmojiSpiral = () => {
  const [emojis, setEmojis] = useState([]);

  useEffect(() => {
    // Create emojis with different positions, delays, and durations
    const emojiElements = [];
    const numEmojis = 30;
    const centerX = window.innerWidth / 2;
    const centerY = window.innerHeight / 2;

    for (let i = 0; i < numEmojis; i++) {
      const randomEmoji = EMOJIS[Math.floor(Math.random() * EMOJIS.length)];
      const delay = Math.random() * 15; // Random delay up to 15s
      const duration = 15 + Math.random() * 10; // Duration between 15-25s
      const top = centerY + Math.random() * 100 - 50 + '%';
      const left = centerX + Math.random() * 100 - 50 + '%';
      const size = 0.8 + Math.random() * 1.2; // Random size between 0.8-2rem
      
      emojiElements.push({
        id: i,
        emoji: randomEmoji,
        style: {
          top,
          left,
          fontSize: `${size}rem`,
          animationDuration: `${duration}s`,
          animationDelay: `${delay}s`,
        },
      });
    }
    
    setEmojis(emojiElements);
  }, []);

  return (
    <Box className="emoji-spiral-container">
      {emojis.map((item) => (
        <Box
          key={item.id}
          className="emoji"
          position="absolute"
          style={item.style}
        >
          {item.emoji}
        </Box>
      ))}
    </Box>
  );
};

export default EmojiSpiral; 